import { render, staticRenderFns } from "./AssistantCategoryUpsertDialog.vue?vue&type=template&id=ed7ecb98"
import script from "./AssistantCategoryUpsertDialog.vue?vue&type=script&lang=js"
export * from "./AssistantCategoryUpsertDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports